/**
 * Modal de captura de la pantalla "Creditos y Movimientos".
 *
 * No trae formulario propio: monta el MISMO componente por-empleado que usa el Sobre Recibo de la
 * prenómina, que ya tiene su tabla, su formulario inline y sus validaciones. Así no hay dos
 * versiones de la misma captura que puedan divergir.
 *
 * Arriba lleva un selector de empleado, para poder abrirlo desde un renglón (con el empleado ya
 * puesto) o desde el botón "Agregar" (sin empleado, se elige aquí).
 */

import React, { Component } from 'react'
import { Alert } from 'antd'
import { connect } from 'react-redux'
import { ModalItem } from '../../../Components/Items'
import SelectEmpleadosItem from '../../../Components/SelectEmpleadosItem'
import InfonvitEmpleado from '../PreNomina/InfonvitEmpleado/InfonvitEmpleado'
import FonacotEmpleado from '../PreNomina/FonacotEmpleado/FonacotEmpleado'
import MovimientosPermanentesEmpleado from '../PreNomina/MovimientosPermanentesEmpleado/MovimientosPermanentesEmpleado'
import IncidenciasPermanentesAutonomo from '../PreNomina/IncidenciasPermanentesEmpleado/IncidenciasPermanentesAutonomo'
import IncapacidadesEmpleado from '../PreNomina/IncapacidadesEmpleado/IncapacidadesEmpleado'
import VacacionesEmpleado from '../PreNomina/VacacionesEmpleado/VacacionesEmpleado'

const COMPONENTES = {
  infonavit: InfonvitEmpleado,
  fonacot: FonacotEmpleado,
  movimientos: MovimientosPermanentesEmpleado,
  incidencias: IncidenciasPermanentesAutonomo,
  incapacidades: IncapacidadesEmpleado,
  vacaciones: VacacionesEmpleado,
}

class ModalEmpleadoNomina extends Component {

  render() {
    const {
      visible, clave, titulo, empleadoId, tipoPeriodoId,
      empresaId, headersToken,
      onCambiarEmpleado, onClose, onCambio,
    } = this.props

    const Componente = COMPONENTES[clave]

    return (
      <ModalItem
        title={titulo}
        visible={visible}
        onCancel={onClose}
        width={1100}
        footer={null}
        destroyOnClose
      >
        <div style={{ marginBottom: 12, paddingTop: 8 }}>
          <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Empleado</div>
          <SelectEmpleadosItem
            empresaId={empresaId}
            headersToken={headersToken}
            value={empleadoId || undefined}
            onChange={onCambiarEmpleado}
            allowClear
            autoFocus={!empleadoId}
            width="100%"
            dropdownMatchSelectWidth={600}
            placeholder="Busca un empleado"
          />
        </div>

        {empleadoId && Componente ? (
          // `key` fuerza el remonte al cambiar de empleado: así el formulario inline no se queda
          // abierto con los datos del anterior.
          <Componente
            key={`${clave}-${empleadoId}`}
            empleadoId={empleadoId}
            tipoPeriodoId={clave === 'incidencias' ? tipoPeriodoId : undefined}
            onCambio={onCambio}
          />
        ) : (
          <Alert
            type="info"
            showIcon
            style={{ marginBottom: 16 }}
            message="Selecciona un empleado"
            description="Elige a quién le vas a capturar o revisar el registro."
          />
        )}
      </ModalItem>
    )
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
})

export default connect(mapStateToProps)(ModalEmpleadoNomina)
